import { RootState } from "@store";
import { useSelector } from "react-redux";

export const useSelectedMiners = () => {
  const miners = useSelector((store: RootState) => store.minersSelect.selected);
  return miners;
};
